import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import React, {createContext, useState} from "react";

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import UserContext from './UserContext';

// ----------------------------------------------------------------------

export default function App() {
    const [user, setUser] = useState(null);
    const value = {user, setUser};

  return (
      <UserContext.Provider value={value}>
          <HelmetProvider>
              <BrowserRouter>
                  <ThemeProvider>
                      <ScrollToTop />
                      <StyledChart />
                      <Router />
                  </ThemeProvider>
              </BrowserRouter>
          </HelmetProvider>
      </UserContext.Provider>
  );
}
